import { z } from 'zod'

export const bargeTankSchema = z.object({
  volume15: z.string().optional(),
})
